module.exports = __webpack_public_path__ + "img/1.156a0f30.jpg";